module.exports = __webpack_public_path__ + "img/keepRoutes.f7cfde40.svg";